import React from "react";

const PlusIcon = () => {
  return (
    <svg
      fill="none"
      viewBox="0 0 24 24"
      width={20}
      height={20}
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
      />
    </svg>
  );
};

export default PlusIcon;